import { useParams } from "react-router-dom";
import ClientFiles from "./buttons/ClientFiles";
import Period from "./buttons/Period";
import { displayH1Production } from "../../services/function";
import Send from "./buttons/Send";
import TimeSpentPerCustomer from "./tables/TimeSpentPerCustomer";
import DetailsOfService from "./tables/DetailsOfService";
import { MonthYearInput } from "../ui/inputs/MonthlyPicker";
import { useProductionStore } from "../../stores/production";
import ProductionByUser from "./tables/ProductionByUser";
import BillingByMonth from "./tables/BillingByMonth";
import InvoicesProduction from "./tables/InvoicesProduction";
import ProductionByDepartment from "./tables/ProductionByDepartment";
import Departments from "./buttons/Departments";
import { getCsvDocumentForProd } from "../../api/customerFile";
import TimeByCollab from "./tables/TimeByCollab";
import Users from "./buttons/Users";
import { YearPicker } from "../ui/inputs/YearPicker";
import TimeSheet from "./tables/TimeSheet";
import SendForTimeSheet from "./buttons/SendForTimeSheet";
import { showToastError } from "../../services/toast";
import Payments from "./tables/Payments";
import useSorting from "../../contexts/useSorting";
import { getSortButtonClasses, getSortIcon } from "../../utils/sortIcons";
import HolidaysAndAbsence from "./tables/HolidaysAndAbsence";
import HolidaysOrAbsence from "./buttons/HolidaysOrAbsence";
import { getCsvDocumentForPayments } from "../../api/payments";
import DetailsForSuperviseur from "./tables/DetailsForSuperviseur";
import SendChargeable from "./buttons/SendChargeable";
import {
  ActionButton,
  PageHeader,
  PagePanel,
  PageShell,
  PanelToolbar,
  SortBar,
} from "../ui/page/PageShell";

const ProductionDetail = () => {
  const { id } = useParams();
  const { formData, setFormData, production2, isLoading } =
    useProductionStore();

  const handleDateChange = (date: string | null) => {
    setFormData({ ...formData, date: date });
  };

  const handleExportPdf = () => {
    if (id === "1") {
      getCsvDocumentForProd(formData.idCustomerFile || "0", formData.startDate, formData.endDate)
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `production_report_${formData.startDate}_${formData.endDate}.csv`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        })
        .catch((err) => {
          showToastError(err.response.data.message);
        });
    } else if (id === "9") {
      getCsvDocumentForPayments(formData.startDate, formData.endDate)
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `production_report_${formData.startDate}_${formData.endDate}.csv`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        })
        .catch((err) => {
          showToastError(err.response.data.message);
        });
    }
  };

  // Hooks de tri pour chaque type de données
  const [
    sortedPayments,
    handleSortPayments,
    paymentsSortField,
    paymentsSortDirection,
  ] = useSorting(production2?.paymentLines);

  return (
    <PageShell>
      <PageHeader
        eyebrow="Production"
        title={displayH1Production(id || "")}
        actions={
          <>
            {(id === "1" || id === "9") && (
              <ActionButton variant="primary" onClick={handleExportPdf}>
                Exporter
              </ActionButton>
            )}
            {/* Si l'id est 8, on affiche le bouton pour envoyer le temps */}
            {id === "8" ? (
              <SendForTimeSheet />
            ) : id === "10" ? (
              <HolidaysOrAbsence />
            ) : id === "11" ? (
              <SendChargeable />
            ) : (
              <Send />
            )}
          </>
        }
      />

      <PagePanel>
        <PanelToolbar>
          <div className="flex flex-wrap items-end gap-3">
            {id === "1" && (
              <>
                <ClientFiles />
                <Period />
              </>
            )}
            {id === "2" && (
              <>
                <Departments />
                <MonthYearInput
                  label="Mois à selectionner"
                  name="date"
                  value={formData.date}
                  onChange={handleDateChange}
                  className="w-auto"
                />
              </>
            )}
            {id === "3" && <Period />}
            {id === "4" && <Period />}
            {id === "5" && (
              <div className="flex flex-wrap items-end gap-3">
                <Period />
                <Departments />
              </div>
            )}
            {id === "6" && <Period />}
            {id === "9" && <Period />}
            {id === "7" && (
              <>
                <Users />
                <YearPicker
                  label="Année à selectionner"
                  name="year"
                  value={formData.date}
                  onChange={handleDateChange}
                  className="w-auto"
                />
              </>
            )}
            {id === "8" && (
              <>
                <Users />
                <MonthYearInput
                  label="Mois à selectionner"
                  name="date"
                  value={formData.date}
                  onChange={handleDateChange}
                  className="w-auto"
                />
              </>
            )}

            {id === "10" && (
              <MonthYearInput
                label="Mois à selectionner"
                name="date"
                value={formData.date}
                onChange={handleDateChange}
                className="w-auto"
              />
            )}
            {id === "11" && (
              <>
                <ClientFiles />
                <YearPicker
                  label="Année à selectionner"
                  name="year"
                  value={formData.date}
                  onChange={handleDateChange}
                  className="w-auto"
                />
              </>
            )}
          </div>

          {/* Filtres et tri */}
          {id === "9" && Object.keys(production2)?.length > 0 && (
            <SortBar>
              <button
                onClick={() => handleSortPayments("date")}
                className={getSortButtonClasses("date", paymentsSortField)}
              >
                <span>Date</span>
                {getSortIcon("date", paymentsSortField, paymentsSortDirection)}
              </button>
              <button
                onClick={() => handleSortPayments("invoiceNumber")}
                className={getSortButtonClasses(
                  "invoiceNumber",
                  paymentsSortField,
                )}
              >
                <span>Numéro Facture</span>
                {getSortIcon(
                  "invoiceNumber",
                  paymentsSortField,
                  paymentsSortDirection,
                )}
              </button>
            </SortBar>
          )}
        </PanelToolbar>

        {/* Contenu principal dynamique */}
        <div className="relative min-h-0 flex-1 overflow-auto p-3 sm:p-4">
          {isLoading ? (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 backdrop-blur-[1px]">
              <div className="size-10 animate-spin rounded-full border-2 border-slate-200 border-t-dca-blue" />
            </div>
          ) : id === "1" && Object.keys(production2)?.length > 0 ? (
            <TimeSpentPerCustomer />
          ) : id === "2" ? (
            <DetailsOfService />
          ) : id === "3" && Object.keys(production2)?.length > 0 ? (
            <ProductionByUser />
          ) : id === "4" && Object.keys(production2)?.length > 0 ? (
            <BillingByMonth />
          ) : id === "5" && Object.keys(production2)?.length > 0 ? (
            <InvoicesProduction />
          ) : id === "6" && Object.keys(production2)?.length > 0 ? (
            <ProductionByDepartment />
          ) : id === "7" ? (
            <TimeByCollab />
          ) : id === "8" && Object.keys(production2)?.length > 0 ? (
            <TimeSheet />
          ) : id === "9" && Object.keys(production2)?.length > 0 ? (
            <Payments sortedPayments={sortedPayments} />
          ) : id === "10" && Object.keys(production2)?.length > 0 ? (
            <HolidaysAndAbsence />
          ) : id === "11" ? (
            <DetailsForSuperviseur />
          ) : null}
        </div>
      </PagePanel>
    </PageShell>
  );
};

export default ProductionDetail;
